import { locateOnce } from "./geoPosition";

// The longest a clock action waits for GPS. The browser's own time-out doesn't
// count time spent on its "allow location?" prompt — one left open (or that
// never answers, like Firefox's "Not now") would hold the clock-in up for good.
const HARD_CAP_MS = 10000;

// The GPS part of a person's own clock-in, switch or clock-out (the server
// keeps it — chariot-backend/utils/clockPlace.js — and works out whether it was
// at the job): a fix, or why there's none. Quick — it never holds a clock-in
// up more than 10 seconds — and never stops one: no GPS is recorded as such.
export async function clockGps() {
  let capTimer;
  const cap = new Promise((resolve) => { capTimer = setTimeout(() => resolve({ error: "timeout" }), HARD_CAP_MS); });
  const fix = await Promise.race([locateOnce({ timeout: 8000, maximumAge: 60000, retry: false }), cap]);
  clearTimeout(capTimer);
  return fix.error
    ? { location_error: fix.error }
    : { latitude: fix.lat, longitude: fix.lng, accuracy: fix.accuracy };
}
